module.exports = __webpack_public_path__ + "img/archive.97582ec6.svg";